import styled from "styled-components";
import Paper from "@material-ui/core/Paper";

export const BWPaper = styled(Paper)`
  border-radius: 0;
  margin-top: 24px;
`;
